/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportDealsTableV2MutationRequest,
  ExportDealsTableV2MutationResponse,
  ExportDealsTableV2400,
  ExportDealsTableV2500,
} from '../types/ExportDealsTableV2'

function getExportDealsTableV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/contacts/deals/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async deals export.
 * @summary Start an async deals table export
 * {@link /api/v1/contacts/deals/export/v2/}
 */
export async function exportDealsTableV2(
  data: ExportDealsTableV2MutationRequest,
  config: Partial<RequestConfig<ExportDealsTableV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportDealsTableV2MutationResponse,
    ResponseErrorConfig<ExportDealsTableV2400 | ExportDealsTableV2500>,
    ExportDealsTableV2MutationRequest
  >({
    method: 'POST',
    url: getExportDealsTableV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
